/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Move_Up_One_LineInputs */



/**
* | output |
* | --- |
* | "Move the Event position up 1 line" |
*
* @param {Shortcut_Keys_Desc_Cc_Move_Up_One_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_move_up_one_line = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Move_Up_One_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Move_Up_One_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer la position de l'evenement d'une ligne vers le haut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschieben Sie die Ereignisposition um eine Zeile nach oben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la posizione dell'evento di 1 riga in alto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместите позицию события на одну строку вверх.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mueva la posición del evento 1 línea hacia arriba")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件位置上移一行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの位置を1行上に移動する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट की स्थिति को 1 पंक्ति ऊपर ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mova a posição do evento uma linha para cima.")
	return /** @type {LocalizedString} */ ("Move the Event position up 1 line")
});